import { createAsyncThunk } from '@reduxjs/toolkit';
import { patchProcountorDimension } from '../services/patchProcountorDimension.service';
import { selectSelectedProject } from 'store/projects/selectors/projectsSelectors';

export const saveProcountorDimension = createAsyncThunk(
  'project/saveProcountorDimension',
  async (dimensionId, { getState }) => {
    const state = getState();
    const selectedProject = selectSelectedProject(state);

    const response = await patchProcountorDimension(
      selectedProject.id,
      dimensionId
    );
    return { ...response, projectId: selectedProject.id };
  }
);
